import React from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTheme } from 'react-jss'
import { withTranslation } from 'react-i18next'

import { ContentBox, Button, FormButtons } from '@portal/kit/pkg/components'

import styles from './confirmation-style'

import ConfirmationContent from '../confirmation-content'

const Confirmation = ({ theme, room, t, viewRanList }) => {
  const classes = styles(theme)

  return (
    <ContentBox title={t('ran_activation_confirmation.title')}>
      <ConfirmationContent room={room} />
      <FormButtons>
        <Button classType="cancel" className={classes.backButton} onClick={viewRanList}>{t('ran_activation_confirmation.wifi_button')}</Button>
        <Button href="/lien-vers-faq">{t('ran_activation_confirmation.faq_button')}</Button>
      </FormButtons>
    </ContentBox>
  )
}

Confirmation.propTypes = {
  viewRanList: PropTypes.func.isRequired,
  room: PropTypes.object.isRequired,
}

export default compose(
  withTheme,
  withTranslation(),
)(Confirmation)
